<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: {
    required: true,
  },
})
const emits = defineEmits(['update:modelValue'])

const computedTarget = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits('update:modelValue', value)
  }
})

const computedName = computed(() => "target_" + Math.random().toString(36).substring(7))
</script>

<template>
  <div>
    <label :for="computedName">{{ __('Open in') }}</label>
    <div class="flex flex-col space-y-1">
      <label><input class="mr-2" type="radio" :name="computedName" v-model="computedTarget" value="_self">{{ __('Same tab') }}</label>
      <label><input class="mr-2" type="radio" :name="computedName" v-model="computedTarget" value="_blank">{{ __('New tab') }}</label>
    </div>
  </div>
</template>

